import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getAuditTrailByid } from '../../../../../../redux/auditTrailSlice'
import { useS3Data } from '../../../../../../hooks/useS3Data'
import { resolveAuditTrailVersionId } from '../../../../utils/auditTrailVersionIdResolve'

const isTruthyMainEntry = (value) =>
  value === true ||
  (typeof value === 'string' && value.trim().toLowerCase() === 'true')

const parseSnapshotData = (snapshotData, isMainEntry, previewTreeNodeId, actionToShow) => {
  if (!snapshotData || typeof snapshotData !== 'object' || Array.isArray(snapshotData)) {
    return { versionContent: null, sections: [] }
  }
  let completeData = null
  console.log("snapshotData" , snapshotData)
  if(
    (snapshotData?.version_content?.action_to_show?.includes('Created') && snapshotData?.version_content?.action_to_show?.includes('Rev')) ||
    snapshotData?.version_content?.action_to_show?.includes('User copied and replaced')
  ){
    completeData = JSON.parse(JSON.stringify(snapshotData))
  }
  else if(actionToShow==="UPDATE_PROCEDURE_REVISION"){
    completeData = {
      version_content: JSON.parse(JSON.stringify(snapshotData)),
    }
  }
  const clone = { ...snapshotData }
  let vc = {}

  let fe = null

  let content = [];

  if('data' in snapshotData){
    content = snapshotData.data
    vc = {...snapshotData, data:undefined}
  }else{
    let block = null;
    vc = clone.version_content ?? null
    delete clone.version_content

    if("first_entry" in clone){
      fe = clone.first_entry
      delete clone.first_entry
    }
    
    if (isMainEntry) {
      const blocks = Object.values(clone)
      block = blocks.length > 0 ? blocks[blocks.length - 1] : null
    } else if (previewTreeNodeId && clone[previewTreeNodeId]) {
      block = clone[previewTreeNodeId]
    }
  
     content =
      block?.new_content ?? block?.newContent ?? block?.['new content'] ?? null
  }

  if(actionToShow==="UPDATE_PROCEDURE_REVISION"){
    completeData.version_content.partNumber = completeData.version_content?.part_number
    completeData.version_content.revision = completeData.version_content?.procedure_rev
    completeData.version_content.status = completeData.version_content?.procedure_status
    vc = completeData.version_content
  }

  return {
    versionContent: vc,
    sections: Array.isArray(content) ? content : [],
    completeData
  }
}

const CHILD_ACTION_MAP = {
  'ATTACHMENT_MOVED': 'attachment',
  'VIDEO_MOVED': 'video',
  'RICH-TEXT_MOVED': 'rich-text',
  'CANVAS_MOVED': 'canva',
  'ATTACHMENT_COPIED': 'attachment',
  'VIDEO_COPIED': 'video',
  'RICH-TEXT_COPIED': 'rich-text',
  'CANVAS_COPIED': 'canva',
  'CANVA_COPIED': 'canva',
}

const findChildInSections = (sections, previewTreeNodeId, resolvedType, empty, treeField = "tree_node_id") => {
  let cumSteps = 0
  let globalTypeCounter = 0

  for (let sIdx = 0; sIdx < sections.length; sIdx++) {
    const sec = sections[sIdx]
    const steps = sec?.steps ?? []
    for (let stIdx = 0; stIdx < steps.length; stIdx++) {
      const step = steps[stIdx]
      const stepChildren = step?.children ?? []
      const sameTypeStepChildren = stepChildren.filter((ch) => ch?.type === resolvedType)

      for (let i = 0; i < sameTypeStepChildren.length; i++) {
        if (sameTypeStepChildren[i]?.[treeField] === previewTreeNodeId) {
          const chIdx = stepChildren.findIndex((ch) => ch?.[treeField] === previewTreeNodeId)
          return { ...empty, type: resolvedType, sectionIndex: sIdx, section: sec, stepIndex: stIdx, childIndex: chIdx, childNode: stepChildren[chIdx], globalChildNumber: globalTypeCounter + i + 1, globalStepStart: cumSteps }
        }
      }
      globalTypeCounter += sameTypeStepChildren.length

      const substeps = step?.substeps ?? []
      for (let subIdx = 0; subIdx < substeps.length; subIdx++) {
        const substep = substeps[subIdx]
        const subChildren = substep?.children ?? []
        const sameTypeSubChildren = subChildren.filter((ch) => ch?.type === resolvedType)

        for (let i = 0; i < sameTypeSubChildren.length; i++) {
          if (sameTypeSubChildren[i]?.[treeField] === previewTreeNodeId) {
            const subChIdx = subChildren.findIndex((ch) => ch?.[treeField] === previewTreeNodeId)
            return { ...empty, type: resolvedType, sectionIndex: sIdx, section: sec, stepIndex: stIdx, substepIndex: subIdx, childIndex: subChIdx, childNode: subChildren[subChIdx], globalChildNumber: globalTypeCounter + i + 1, globalStepStart: cumSteps }
          }
        }
        globalTypeCounter += sameTypeSubChildren.length
      }
    }
    cumSteps += steps.length
  }
  return null
}

const resolveMovedCopyNode = (actionToShow, sections, previewTreeNodeId, snapshotData, version_content) => {
  const empty = { type: null, sectionIndex: -1, section: null, stepIndex: -1, substepIndex: -1, childIndex: -1, childNode: null, globalStepStart: 0 }
  let isNotRevCreatedEntry = !(version_content?.action_to_show?.includes('Created') && version_content?.action_to_show?.includes('Rev'))
  let isNotCopiedReplacedEntry = !version_content?.action_to_show?.includes('User copied and replaced')

  if( actionToShow === 'REVISION_COPIED' || actionToShow === 'UPDATE_PROCEDURE_REVISION' ){
    return { ...empty, type: 'revision', sections: sections,version_content }
  }

  if (sections.length === 0 || !previewTreeNodeId) return empty

  if (actionToShow === 'SECTION_MOVED' || actionToShow === 'SECTION_COPIED') {
    const secIdx = sections.findIndex((s) => {

      if(actionToShow === 'SECTION_COPIED' && isNotRevCreatedEntry && isNotCopiedReplacedEntry)
        return s?.previous_tree_node_id === previewTreeNodeId

      return s?.tree_node_id === previewTreeNodeId
    })
    if (secIdx < 0) return empty
    const globalStepStart = sections
      .slice(0, secIdx)
      .reduce((sum, s) => sum + (s?.steps?.length || 0), 0)
    return { ...empty, type: 'section', sectionIndex: secIdx, section: sections[secIdx], globalStepStart }
  }

  if (actionToShow === 'STEP_MOVED' || actionToShow === 'STEP_COPIED') {
    let cumSteps = 0
    for (let sIdx = 0; sIdx < sections.length; sIdx++) {
      const sec = sections[sIdx]
      const steps = sec?.steps ?? []
      const stIdx = steps.findIndex((st) => {
        if (actionToShow === 'STEP_COPIED' && isNotRevCreatedEntry && isNotCopiedReplacedEntry)
          return st?.previous_tree_node_id === previewTreeNodeId

        return st?.tree_node_id === previewTreeNodeId
      })
      if (stIdx >= 0) {
        return { ...empty, type: 'step', sectionIndex: sIdx, section: sec, stepIndex: stIdx, globalStepStart: cumSteps }
      }
      cumSteps += steps.length
    }
  }

  if (actionToShow === 'SUBSTEP_MOVED' || actionToShow === 'SUBSTEP_COPIED') {
    let cumSteps = 0
    for (let sIdx = 0; sIdx < sections.length; sIdx++) {
      const sec = sections[sIdx]
      const steps = sec?.steps ?? []
      for (let stIdx = 0; stIdx < steps.length; stIdx++) {
        const step = steps[stIdx]
        const substeps = step?.substeps ?? []
        const subIdx = substeps.findIndex((sub) => {
          if (actionToShow === 'SUBSTEP_COPIED' && isNotRevCreatedEntry && isNotCopiedReplacedEntry)
            return sub?.previous_tree_node_id === previewTreeNodeId

          return sub?.tree_node_id === previewTreeNodeId
        })
        if (subIdx >= 0) {
          return { ...empty, type: 'substep', sectionIndex: sIdx, section: sec, stepIndex: stIdx, substepIndex: subIdx, globalStepStart: cumSteps }
        }
      }
      cumSteps += steps.length
    }
  }

  const childType = CHILD_ACTION_MAP[actionToShow]
  if (childType) {
    const result = findChildInSections(sections, previewTreeNodeId, childType, empty, actionToShow.includes('_COPIED') && (!("data" in snapshotData) && isNotRevCreatedEntry && isNotCopiedReplacedEntry) ? "previous_tree_node_id" : "tree_node_id")
    if (result) return result
  }

  return empty
}

/**
 * Checkbox focus id must match the row `tree_node_id` in the loaded snapshot.
 * For move/copy audits, `preview_tree_node_id` on the audit often matches `previous_tree_node_id`
 * while the tree row carries a new `tree_node_id` — without this, the focused row never looks "selected".
 */
const resolveCheckboxFocusId = (resolved, previewTreeNodeId) => {
  if (!previewTreeNodeId) return previewTreeNodeId
  if (!resolved || resolved.type == null) return previewTreeNodeId
  switch (resolved.type) {
    case 'section':
      return (
        resolved.section?.tree_node_id ??
        resolved.section?.previous_tree_node_id ??
        previewTreeNodeId
      )
    case 'step': {
      const st = resolved.section?.steps?.[resolved.stepIndex]
      return st?.tree_node_id ?? st?.previous_tree_node_id ?? previewTreeNodeId
    }
    case 'substep': {
      const sub =
        resolved.section?.steps?.[resolved.stepIndex]?.substeps?.[
          resolved.substepIndex
        ]
      const sd = sub?.detail || {}
      return (
        sub?.tree_node_id ??
        sub?.previous_tree_node_id ??
        sd.sub_step_tree_node_id ??
        previewTreeNodeId
      )
    }
    case 'attachment':
    case 'video':
    case 'rich-text':
    case 'canva':
      return (
        resolved.childNode?.tree_node_id ??
        resolved.childNode?.previous_tree_node_id ??
        previewTreeNodeId
      )
    default:
      return previewTreeNodeId
  }
}

const buildCheckboxState = (resolvedType, previewTreeNodeId, resolved) => {
  const auditPreviewCurrentNode = { auditPreviewCurrentNode: true }
  const focusId = resolveCheckboxFocusId(resolved, previewTreeNodeId)
  if (resolvedType === 'section') {
    return {
      currentNodeId: focusId,
      currentNodeType: 'section',
      sourceNodeId: null,
      allChildrenChecked: true,
      ...auditPreviewCurrentNode,
    }
  }
  if (resolvedType === 'step') {
    return {
      currentNodeId: focusId,
      currentNodeType: 'step',
      sourceNodeId: null,
      allChildrenChecked: false,
      ...auditPreviewCurrentNode,
    }
  }
  if (resolvedType === 'substep') {
    return {
      currentNodeId: focusId,
      currentNodeType: 'substep',
      sourceNodeId: null,
      /**
       * Rich text/canvas/etc. uses `allChildrenChecked` + `auditDescendantPreviewLocked`
       * (see RichTextNode) for checked+inactive tiles when the parent row is only the structural focus entry.
       * SubstepNode ignores bulk `allChildrenChecked` when `currentNodeType === 'substep'` so this row stays driven by `isCurrent` only.
       */
      allChildrenChecked: true,
      auditDescendantPreviewLocked: true,
      ...auditPreviewCurrentNode,
    }
  }
  if (['attachment', 'video', 'rich-text', 'canva'].includes(resolvedType)) {
    return {
      currentNodeId: focusId,
      currentNodeType: resolvedType,
      sourceNodeId: null,
      allChildrenChecked: false,
      ...auditPreviewCurrentNode,
    }
  }
  return null
}

const buildDisplayTitle = (versionId, resolved) => {
  if (!versionId) return 'Loading...'
  const suffix = `(Version ${versionId}) Selected`
  if (resolved.type === 'section' && resolved.sectionIndex >= 0) {
    return `Section ${resolved.sectionIndex + 1} ${suffix}`
  }
  if (resolved.type === 'step' && resolved.stepIndex >= 0) {
    return `Step ${resolved.globalStepStart + resolved.stepIndex + 1} ${suffix}`
  }
  if (resolved.type === 'substep' && resolved.substepIndex >= 0) {
    const stepNum = resolved.globalStepStart + resolved.stepIndex + 1
    const substepLetter = String.fromCharCode(65 + resolved.substepIndex)
    return `Substep ${stepNum}${substepLetter} ${suffix}`
  }
  const childLabelMap = { attachment: 'Attachment', video: 'Video', 'rich-text': 'Rich Text', canva: 'Canvas' }
  if (childLabelMap[resolved.type] && resolved.childNode) {
    return `${childLabelMap[resolved.type]} ${resolved.globalChildNumber ? `${resolved.globalChildNumber} ` : ''}${suffix}`
  }
  if(resolved.type === 'revision'){
    return `${resolved?.version_content?.item_code_type} ${resolved?.version_content?.partNumber || resolved?.version_content?.part_number} ${suffix}`
  }
  return `Preview ${suffix}`
}

const useCurrentNodeData = (auditTrailId) => {
  const dispatch = useDispatch()

  const [auditTrailData, setAuditTrailData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true
    setLoading(true)
    setError(null)

    dispatch(getAuditTrailByid({ id: auditTrailId }))
      .unwrap()
      .then((data) => {
        if (isMounted) setAuditTrailData(data?.results ?? data)
      })
      .catch((err) => {
        if (isMounted) setError(err?.message || err || 'Failed to fetch audit trail data')
      })
      .finally(() => {
        if (isMounted) setLoading(false)
      })

    return () => { isMounted = false }
  }, [dispatch, auditTrailId])

  const {
    data: snapshotData,
    loading: snapshotLoading,
    error: snapshotError,
  } = useS3Data(auditTrailData?.new_content_snapshot)

  const auditVc = auditTrailData?.version_content ?? {}
  const actionToShow = auditVc.action_to_show ?? ''
  const previewTreeNodeId = auditVc.preview_tree_node_id
  const isMainEntry = isTruthyMainEntry(auditVc.main_entry ?? auditVc.version_content?.main_entry)

  const { versionContent, sections, completeData } = useMemo(
    () => parseSnapshotData(snapshotData, isMainEntry, previewTreeNodeId, auditVc.action_to_show),
    [snapshotData, isMainEntry, previewTreeNodeId],
  )

  const resolved = useMemo(
    () => resolveMovedCopyNode(actionToShow, sections, previewTreeNodeId,snapshotData,versionContent),
    [actionToShow, sections, previewTreeNodeId,snapshotData],
  )

  const checkboxState = useMemo(
    () => buildCheckboxState(resolved.type, previewTreeNodeId, resolved),
    [resolved.type, previewTreeNodeId, resolved],
  )

  const displayTitle = useMemo(
    () =>
      buildDisplayTitle(
        resolveAuditTrailVersionId(auditTrailData),
        resolved,
      ),
    [auditTrailData, resolved],
  )

  const cancel_screen_data = {
      ...versionContent,
      data:sections
  }


  let canPerformCopyAndReplace = false; 
  if(auditVc.action_to_show === "REVISION_COPIED" || auditVc.action_to_show === "UPDATE_PROCEDURE_REVISION" ){
    canPerformCopyAndReplace = true
    // if(versionContent?.part_number){
    //   cancel_screen_data.partNumber = versionContent?.part_number
    // }
  }

  console.log("versionContent", versionContent)

  return {
    auditTrailData,
    loading,
    error,
    snapshotLoading,
    snapshotError,
    versionContent,
    sections,
    resolved,
    checkboxState,
    displayTitle,
    previewTreeNodeId,
    hasSnapshotUrl: !!auditTrailData?.new_content_snapshot,
    part_ref:auditVc?.first_entry ?versionContent?.part_ref : sections?.[0]?.part_ref,
    procedure_rev_ref:auditVc?.first_entry ?versionContent?.procedure_rev_ref : sections?.[0]?.procedure_rev_ref,
    isMainEntry,
    new_content_snapshot:auditTrailData?.new_content_snapshot,
    cancel_screen_data,
    data_for_copy_and_replace:{
      completeData,
      auditVc,
      canPerformCopyAndReplace
    }
  }
}

export default useCurrentNodeData